<template>
    <div>
        <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
            {{ $t('Texte für Mahndokumente') }}
        </h3>
        <div
            class="kgr-alert kgr-alert--info kgr-row"
            v-html="$t('Hier kannst du die Texte hinterlegen, die auf den Mahnungen und der Rücklastschrift-Information erscheinen sollen.')"
        ></div>

        <div class="kgr-grid kgr-grid--1of2 kgr-grid--gutters kgr-grid--bigGutters">
            <div class="kgr-grid__cell">
                <kgr-form-row
                    :label="$t('Kopftext-Hinweis zur Zahlungserinnerung')"
                    :error="error"
                    field-name="clubDunningLevel1[pdfText]"
                >
                    <textarea
                        v-model.trim="clubDunningSettings.clubDunningLevel1.pdfText"
                        type="text"
                        rows="3"
                        class="kgr-input"
                    ></textarea>
                </kgr-form-row>
            </div>
            <div class="kgr-grid__cell">
                <kgr-form-row
                    :label="$t('Fußtext-Hinweis zur Zahlungserinnerung')"
                    :error="error"
                    field-name="clubDunningLevel1[pdfTextFooter]"
                >
                    <textarea
                        v-model.trim="clubDunningSettings.clubDunningLevel1.pdfTextFooter"
                        type="text"
                        rows="3"
                        class="kgr-input"
                    ></textarea>
                    <kgr-checkbox
                        v-model="clubDunningSettings.clubDunningLevel1.showBankDetails"
                        class="mb1"
                        :label="$t('Bankverbindung und Zahlungsziel auf Mahnung anzeigen')"
                    />
                </kgr-form-row>
            </div>
            <hr class="kgr-separator kgr-separator--light" />
            <div class="kgr-grid__cell">
                <kgr-form-row
                    :label="$t('Kopftext-Hinweis zur 1. Mahnung')"
                    :error="error"
                    field-name="clubDunningLevel2[pdfText]"
                >
                    <textarea
                        v-model.trim="clubDunningSettings.clubDunningLevel2.pdfText"
                        type="text"
                        rows="3"
                        class="kgr-input"
                    ></textarea>
                </kgr-form-row>
            </div>
            <div class="kgr-grid__cell">
                <kgr-form-row
                    :label="$t('Fußtext-Hinweis zur 1. Mahnung')"
                    :error="error"
                    field-name="clubDunningLevel2[pdfTextFooter]"
                >
                    <textarea
                        v-model.trim="clubDunningSettings.clubDunningLevel2.pdfTextFooter"
                        type="text"
                        rows="3"
                        class="kgr-input"
                    ></textarea>
                    <kgr-checkbox
                        v-model="clubDunningSettings.clubDunningLevel2.showBankDetails"
                        class="mb1"
                        :label="$t('Bankverbindung und Zahlungsziel auf Mahnung anzeigen')"
                    />
                </kgr-form-row>
            </div>
            <hr class="kgr-separator kgr-separator--light" />
            <div class="kgr-grid__cell">
                <kgr-form-row
                    :label="$t('Kopftext-Hinweis zur 2. Mahnung')"
                    :error="error"
                    field-name="clubDunningLevel3[pdfText]"
                >
                    <textarea
                        v-model.trim="clubDunningSettings.clubDunningLevel3.pdfText"
                        type="text"
                        rows="3"
                        class="kgr-input"
                    ></textarea>
                </kgr-form-row>
            </div>
            <div class="kgr-grid__cell">
                <kgr-form-row
                    :label="$t('Fußtext-Hinweis zur 2. Mahnung')"
                    :error="error"
                    field-name="clubDunningLevel3[pdfText]"
                >
                    <textarea
                        v-model.trim="clubDunningSettings.clubDunningLevel3.pdfTextFooter"
                        type="text"
                        rows="3"
                        class="kgr-input"
                    ></textarea>
                    <kgr-checkbox
                        v-model="clubDunningSettings.clubDunningLevel3.showBankDetails"
                        class="mb1"
                        :label="$t('Bankverbindung und Zahlungsziel auf Mahnung anzeigen')"
                    />
                </kgr-form-row>
            </div>
            <hr class="kgr-separator kgr-separator--light" />
            <div class="kgr-grid__cell">
                <kgr-form-row
                    :label="$t('Kopftext-Hinweis zur 3. Mahnung')"
                    :error="error"
                    field-name="clubDunningLevel4[pdfText]"
                >
                    <textarea
                        v-model.trim="clubDunningSettings.clubDunningLevel4.pdfText"
                        type="text"
                        rows="3"
                        class="kgr-input"
                    ></textarea>
                </kgr-form-row>
            </div>
            <div class="kgr-grid__cell">
                <kgr-form-row
                    :label="$t('Fußtext-Hinweis zur 3. Mahnung')"
                    :error="error"
                    field-name="clubDunningLevel4[pdfTextFooter]"
                >
                    <textarea
                        v-model.trim="clubDunningSettings.clubDunningLevel4.pdfTextFooter"
                        type="text"
                        rows="3"
                        class="kgr-input"
                    ></textarea>
                    <kgr-checkbox
                        v-model="clubDunningSettings.clubDunningLevel4.showBankDetails"
                        class="mb1"
                        :label="$t('Bankverbindung und Zahlungsziel auf Mahnung anzeigen')"
                    />
                </kgr-form-row>
            </div>
            <hr class="kgr-separator kgr-separator--light" />
            <div class="kgr-grid__cell">
                <kgr-form-row
                    :label="$t('Kopftext-Hinweis zur Rücklastschrift-Information')"
                    :error="error"
                    field-name="chargebackPdfText"
                >
                    <textarea
                        v-model.trim="clubDunningSettings.chargebackPdfText"
                        type="text"
                        rows="3"
                        class="kgr-input"
                    ></textarea>
                </kgr-form-row>
            </div>
            <div class="kgr-grid__cell">
                <kgr-form-row
                    :label="$t('Fußtext-Hinweis zur Rücklastschrift-Information')"
                    :error="error"
                    field-name="chargebackPdfText"
                >
                    <textarea
                        v-model.trim="clubDunningSettings.chargebackPdfTextFooter"
                        type="text"
                        rows="3"
                        class="kgr-input"
                    ></textarea>
                    <kgr-checkbox
                        v-model="clubDunningSettings.chargebackShowBankDetails"
                        class="mb1"
                        :label="$t('Bankverbindung und Zahlungsziel auf Rücklastschrift-Information anzeigen')"
                    />
                </kgr-form-row>
            </div>
        </div>
    </div>
</template>

<script>
import Checkbox from '../../common/form/checkbox/Checkbox';
import ClubDunningSettings from '../../../js/dto/ClubDunningSettings';
import Error from '../../../js/model/Error';
import FormRow from '../../common/form/FormRow';

export default {
    components: {
        'kgr-form-row': FormRow,
        'kgr-checkbox': Checkbox,
    },
    props: {
        clubDunningSettings: {
            type: ClubDunningSettings,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
};
</script>
